// extracted by mini-css-extract-plugin
module.exports = {"card":"s-module--card--2xrqM"};